import ArrowIcon from "@mui/icons-material/ArrowDropDownRounded";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { CONTENT_TYPE } from "@Utils/constants/content";
import { pluralise } from "@Utils/common";
import { COURSE_CONTENT_ICONS, isEmpty } from "@Utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC } from "react";
import Image from "next/image";
import { capitaliseWords } from "repoV2/utils/common/dataTypes/string";
import styles from "./curriculum.module.scss";
import useCurriculum from "./useCurriculum";

const MEDIA_ICONS = {
    [CONTENT_TYPE.VIDEO]: COURSE_CONTENT_ICONS.MEDIA.VIDEO,
    [CONTENT_TYPE.IMAGE]: COURSE_CONTENT_ICONS.MEDIA.IMAGE,
    [CONTENT_TYPE.HTML]: COURSE_CONTENT_ICONS.MEDIA.TEXT,
    [CONTENT_TYPE.PDF]: COURSE_CONTENT_ICONS.MEDIA.FILE,
    [CONTENT_TYPE.HYPERLINK]: COURSE_CONTENT_ICONS.MEDIA.LINK,
    [CONTENT_TYPE.EMBED]: COURSE_CONTENT_ICONS.MEDIA.EMBED,
    [CONTENT_TYPE.DOWNLOAD]: COURSE_CONTENT_ICONS.MEDIA.FILE,
    [CONTENT_TYPE.LIVE_SESSION]: COURSE_CONTENT_ICONS.MEDIA.LIVE,
    [CONTENT_TYPE.EXAM]: COURSE_CONTENT_ICONS.MEDIA.EXAM,
    [CONTENT_TYPE.FORM]: COURSE_CONTENT_ICONS.MEDIA.LIST,
};

const Curriculum: FC = () => {
    const { showCurriculum, catalogue, wordUsedForCourse } = useCurriculum();

    if (!showCurriculum || isEmpty(catalogue)) return null;

    return (
        <div className={styles.root}>
            <h2 className={styles.heading}>
                {capitaliseWords(wordUsedForCourse)} curriculum
            </h2>

            {catalogue?.map(
                ({ title, sub_categories, uuid, lesson_count }, index) => (
                    <Accordion
                        key={uuid}
                        defaultExpanded={index === 0}
                        square
                        classes={{
                            expanded: styles.expanded,
                            root: styles.accordionRoot,
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ArrowIcon />}
                            classes={{
                                root: styles.summary,
                                expanded: styles.summaryExpanded,
                                content: styles.summaryContent,
                                expandIconWrapper: styles.summaryIconWrapper,
                            }}
                        >
                            <div className={styles.titleContainer}>
                                <h2>{title}</h2>

                                <div>
                                    {lesson_count}{" "}
                                    {pluralise("lesson", lesson_count)}
                                </div>
                            </div>
                        </AccordionSummary>

                        <AccordionDetails className={styles.accordionDetails}>
                            {sub_categories.map(
                                ({
                                    title: subCategoryTitle,
                                    uuid: subCategoryUuid,
                                    content_count,
                                    last_content_type,
                                }) => (
                                    <div
                                        key={subCategoryUuid}
                                        className={classNames(styles.lesson)}
                                    >
                                        {content_count === 1 ? ( // show content type icon only if this lesson contains 1 item only
                                            <Image
                                                src={
                                                    MEDIA_ICONS[
                                                        last_content_type
                                                    ]
                                                }
                                                height={20}
                                                width={20}
                                            />
                                        ) : (
                                            <div className={styles.dot} />
                                        )}

                                        {subCategoryTitle}
                                    </div>
                                )
                            )}
                        </AccordionDetails>
                    </Accordion>
                )
            )}
        </div>
    );
};

export default Curriculum;
